import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { fetchAdminAvailabilityRequestStats } from '../../actions/adminActions'
import { Stat } from './Stats'

export const AvailabilityRequestStats = () => {
  const dispatch = useDispatch()
  const admin = useSelector(store => store.admin)

  useEffect(() => {
    dispatch(fetchAdminAvailabilityRequestStats())
  }, [])

  const stats = useMemo(
    () => [
      {
        title: 'Premium / Active Requests',
        value: admin.availabilityRequestStats?.activePremium,
        value2: admin.availabilityRequestStats?.active
      },
      {
        title: 'Premium / Active w/ Matches',
        value: admin.availabilityRequestStats?.activeMatchesPremium,
        value2: admin.availabilityRequestStats?.activeMatches
      }
    ],
    [admin.availabilityRequestStats]
  )

  return (
      stats.map(stat => (
        <Stat stat={stat} />
      ))
  )
}

export default AvailabilityRequestStats
